export enum PaymentModeEnum {
  COD = 'COD',
  CONTADO = 'Contado',
  CREDIT = 'Crédito',
}

export enum PaymentModeId {
  COD = '2',
  CONTADO = '1',
  CREDIT = '3',
  CREDITTAQUILLAORIGEN = '4',
  CREDITTAQUILLADESTINO = '5',
  EXENTO = '6',
}
